import React from 'react'
import { useRouteError } from 'react-router-dom'
import NetworkErrorModal from './NetworkErrorModal'

const RouteErrorBoundary: React.FC = () => {
  useRouteError()

  return <NetworkErrorModal open variant="chunk" />
}

export default RouteErrorBoundary
